import '../../modules/mode-components';

import * as angular from 'angular';
import Headroom from 'headroom.js';

function stickyHeaderDirective() {
  return {
    scope: {
      tolerance: '=',
      offset: '=',
      classes: '=',
      scroller: '@',
    },
    link: function ($scope, $element) {
      const options: any = {};
      const opts = Headroom.options;
      for (const prop in opts) {
        options[prop] = $scope[prop] || opts[prop];
      }
      if ($scope.scroller) {
        options.scroller = document.querySelector($scope.scroller);
      }
      const headroom = new Headroom($element[0], options).init();
      $scope.$on('$destroy', function () {
        headroom.destroy();
      });
    },
  };
}

angular.module('mode.components').directive('stickyHeader', stickyHeaderDirective);
